import { sk1,sk2,sk3,omeg,easy,moviebox,paint,dey4u,schnoze,rent,hotel, stream } from "../assets";
 
 const p_projects = [
    {
      title: "Real Meal",
      description: "Food recipe app created with React and conatains data from spoonacular API",
      imgUrl: sk1,
      url: "https://realmeal.vercel.app",
      tools:["React","Spoonacular Api","Bootstrap","javascript"]

    },
    {
      title: "Model Website",
      description: "portfolio project",
      imgUrl: sk3,
      url:"https://rw-690foelyy-b-lovedth.vercel.app",
      tools:["Flask","Html","Bootstrap","javascript","python"]
    },
    {
      title: "TrackKraft",
      description: "Buisness website",
      imgUrl: sk2,
      url: "https://track-kraft.vercel.app",
      tools:["React","Bootstrap","javascript"]
    },    
    {
      title: "Paint App",
      description: "A simple paint canvas",
      imgUrl: paint,
      url: "https://paint-canvas.vercel.app",
      tools:["HTML","CSS","javascript","Canvas API"]
    },
    {
      title: "Schnoz",
      description: "website dedcated to schnoz project(WEB3)",
      imgUrl: schnoze,
      url: "https://schnoze.vercel.app",
      tools:["HTML","CSS","Javascript"]
    },
    {
      title: "Moviebox",
      description: "movie discovery web application",
      imgUrl: moviebox,
      url: "https://movie-box-kappa.vercel.app/",
      tools:["HTML","CSS","React","TMDB API","Styled-Components", "Etc."]
    }
  ];
  const c_projects = [
    {
      title: "Streamfutball",
      description: "A football streaming application",
      imgUrl: stream,
      url: "https://streamfutball.com",
      tools:["NextJS","SCSS","Typescript","Redux","NodeJS","Socket.io","Etc."]
    },
    {
        title: "Hotel Appliicaton",
        description: "A Hotel booking application",
        imgUrl:hotel ,
        url: "http://hotelapplicationfrontend.netlify.app",
        tools:["NextJS","Styled-Components","Typescript","Redux","NodeJS","ExpressJS","MongoDB","Socket.io","Etc."]
    },
    {
        title: "RentSpace Tech",
        description: "A fintech company website",
        imgUrl: rent,
        url: "https://rentspace-website.vercel.app/",
        tools:["NextJS","CSS Modules","Typescript"]
    },
    {
      title:"Dey4U",
      description:"A marketing Platform for vendors and artisans",
      imgUrl:dey4u,
      url:"https://dey4u.com",
      tools:["Flask","Python","Javascript","CSS","HTML","SQLite"]
    },
    {
      title: "OmegUk Power Solutions",
      description: "A company website",
      imgUrl: omeg,
      url: "https://omeguk.com",
      tools:["Flask","Html","Bootstrap","javascript","python"]
    },
    {
      title: "Easytransact",
      description: "A model of a modern payment gateway",
      imgUrl: easy,
      url: "https://easytransact.me",
      tools:["Flask","Html","Bootstrap","javascript","python"]
    },

  ];

  export {p_projects, c_projects};